import { render } from "./ProjectsBlock.vue?vue&type=template&id=1322844c&scoped=true"
import script from "./ProjectsBlock.vue?vue&type=script&lang=js"
export * from "./ProjectsBlock.vue?vue&type=script&lang=js"

import "./ProjectsBlock.vue?vue&type=style&index=0&id=1322844c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1322844c"]])

export default __exports__